<template>
    <div class="borrow">
        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <DatePicker type="date" v-model="start" placeholder="选择开始日期" style="width: 200px" />
            <DatePicker type="date" v-model="end" placeholder="选择结束日期" style="width: 200px" />
            <Button type="primary" @click="loadData(currentPage)">搜索</Button>
            <Button type="primary" @click="addModal">{{$t('add')}} {{$t('message')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6" style="width: 100%;">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="edit_modal" :title="$t('edit')+$t('message')" @on-ok="edit_modal_ok">
            <Form :model="modalItem" :label-width="100">
                <FormItem :label="$t('type')">
                    <Select v-model="modalItem.type" style="width:200px">
                        <Option value="notice">{{$t('notice')}}</Option>
                        <Option value="blind">{{$t('menu.blind_boxes')}}</Option>
                        <Option value="email">email</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('alert')">
                    <Checkbox :value="modalItem.alert == 1">
                        {{$t('menu.blind_boxes')+$t('alert')}}
                    </Checkbox>
                    <Checkbox :value="modalItem.is_system == 1">
                    {{$t('system_alert')}}
                    </Checkbox>
                </FormItem>
                <FormItem :label="$t('content')">
                    <Input v-model="modalItem.content"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="add_modal" :title="$t('add')+$t('message')" @on-ok="add_modal_ok">
            <div class="search">
                <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
                <Button type="primary" @click="searchData">{{$t('searchText')}}</Button>
            </div>
            <div class="data_list">
                <div class="data_item" v-for="item in data_list" :key="item.id" @click="selectUser(item.user_id)">
                <div class="list_item" :class="{'selected': selectedUserId === item.user_id}">
                    <div class="data_item_content">{{item.username}}</div>
                    <div class="data_item_type">{{item.mobile}}</div>
                    <div class="data_item_email">{{item.email}}</div>
                  </div>
                </div>
            </div>
            <Form :model="modalItem" :label-width="100">
                <FormItem :label="$t('type')">
                    <Select v-model="type" multiple style="width:200px">
                        <Option v-for="item in typeOptions" :key="item.value" :value="item.value">
                            {{ item.labelKey === 'email' ? 'email' : $t(item.labelKey) }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('alert')">
                    <Checkbox :value="modalItem.alert == 1">
                        {{$t('menu.blind_boxes')+$t('alert')}}
                    </Checkbox>
                    <Checkbox :value="modalItem.is_system == 1">
                    {{$t('system_alert')}}
                    </Checkbox>
                    
                </FormItem>
                <FormItem :label="$t('weight')">
                    <Input type="number" v-model="modalItem.weight"></Input>
                </FormItem>
                <FormItem :label="$t('status')">
                    <Select v-model="modalItem.status" style="width:200px">
                        <Option value="1">{{$t('open')}}</Option>
                        <Option value="0">{{$t('close')}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('content')">
                    <Input v-model="modalItem.content"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal
            v-model="showDelModal"
            :title="$t('confirmDel')"
            @on-ok="delRow()"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>
    </div>
</template>
<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';
export default {
    data() {
        return {
            modalItem: {
               
            },
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: "",
            start:'',
            end:'',
            type: [],
            totalItems: 1,
            edit_money: false,
            edit_money2: false,
            change_sts: false,
            withdrawEnabled:false,
            withdrawReject:false,
            showBankNumModal: false,
            jt_img: false,
            edit_modal: false,
            add_modal: false,
            selectedUserId: 0,
            data_list: [],
            typeOptions: [
                { value: 'notice', labelKey: 'notice' },
                { value: 'blind', labelKey: 'menu.blind_boxes' },
                { value: 'email', labelKey: 'email' }
            ],
            columns12: [
                {
                    title: "ID",
                    width: 60,
                    key: "id",
                },
                
                {
                    title: this.$i18n.t('event_type'),
                    width: 150,
                    key: "type",
                    render: (h, params) => {
                        return h("span", params.row.type==="notice" ? this.$i18n.t('notice') :params.row.type==="blind" ? this.$i18n.t('menu.blind_boxes') : 'email')
                    }
                },
                {
                    title: this.$i18n.t('userView.cname'),
                    width: 80,
                    key: "member_username",
                },
                {
                    title: this.$i18n.t('content'),
                    width: "auto",
                    key: "content",
                },
                
                {
                    title: this.$i18n.t('view')+'/'+this.$i18n.t('not_view'),
                    width: 130,
                    key: "is_show",
                    render: (h, params) => {
                        return h("span",{style:{color: 
                            params.row.is_show == 1 ? 'green' : 'red'}}, params.row.is_show == 1 ? this.$i18n.t('view') : this.$i18n.t('not_view'),)
                    }
                },
               
                {
                    title: this.$i18n.t('time'),
                    width: 150,
                    key: "created_at",
                    render: (h, params) => {
                        return h("div", [
                            h("div", formatUTC(params.row.created_at, 8))
                        ]);
                    }
                },
                {
                    title: this.$i18n.t('status'),
                    width:60,
                    key: "status",
                    render: (h, params) => {
                         if (params.row.status==0) {
                            return h("Icon", {
                            props: {
                                type: 'md-checkmark',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'green',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.edit_status(params.row.id, 1)
                                }
                            }
                        });
                    } else {
                        return h("Icon", {
                            props: {
                                type: 'md-close',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'red',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.edit_status(params.row.id, 0)
                                }
                            }
                        });
                    }}
                },
                {
                    title: this.$i18n.t('edit'),
                    width:60,
                    key: "edit",
                    render: (h, params) => {
                        return h("Icon", {
                            props: {
                                type: 'md-create',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'blue',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.editModal(params.row)
                                }
                            }
                        }, this.$i18n.t('edit'));
                    }
                },
                {
                    title: this.$i18n.t('del'),
                    width:60,
                    key: "del",
                    render: (h, params) => {
                        return h("Icon", {
                            props: {
                                type: 'md-trash',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'red',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.delModal(params.row.id)
                                }
                            }
                        });
                    }
                }
        
            ],
            data6: []
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.msg, {
                page: this.currentPage,
                search: this.search,
                start: this.start,
                end: this.end
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        showUserDetail(user_id) {
            this.$router.push({
                name: "user_detail",
                query: {
                    user_id: user_id
                }
            });
        },
        delRow() {
            this.$post(this.$path.msg_del, {
                id: this.userIdToDel
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(id) {
            this.userIdToDel = id;
            this.showDelModal = true;
        },
        editModal(row) {
            this.modalItem = {
                id: row.id,
                content: row.content,
                type: row.type,
                alert: row.alert,
                is_system: row.is_system
            };
            this.edit_modal = true;
        },
        edit_modal_ok() {
           
            this.$post(this.$path.msg_edit, {
                id: this.modalItem.id,
                content: this.modalItem.content,
                type: this.modalItem.type,
                alert: this.modalItem.alert,
                is_system: this.modalItem.is_system
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.edit_modal = false;
                    this.modalItem = { type: [] };
                }else{
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        edit_status(id,status) {
            this.$post(this.$path.msg_edit, {
                id: id,
                status: status
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        selectUser(id) {
            // console.log(id);
            this.selectedUserId = id;
            this.modalItem.user_id = id;
            // this.add_modal = false;
        },
        searchData() {
            this.$get(this.$path.user_search, {
                search: this.search,
                page: this.currentPage,
                pageSize: this.itemsPerPage,
                type: "user"
            }).then(res => {
                if (res.success) {
                    this.data_list = res.data.list;
                }
            });
        },
        add_modal_ok() {
            // 将 type 数组转换为逗号分隔的字符串格式（后端期望字符串）
            this.$post(this.$path.msg_add, {
                user_id: this.modalItem.user_id,
                content: this.modalItem.content,
                type: this.type,
                weight: this.modalItem.weight,
                status: this.modalItem.status,
                alert: this.modalItem.alert,
            }).then(res => {
                
                if (res.errcode==0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }else{
                    this.$Message.error(res.error);
                }
            }).finally(() => {
                this.add_modal = false;
                this.modalItem = {}
                this.type = []
            });
        },
        addModal() {
            // 确保完全重置 modalItem，type 是数组（支持多选）
            this.modalItem = {
                type: [],
                alert: 0,
                is_system: 0,
                user_id: null,
                content: '',
                weight: '',
                status: '1'
            };
            this.selectedUserId = 0;
            this.add_modal = true;
        },
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%; 
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}
.list_item {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover {
        background-color: #f0f0f0;
    }
}
.selected{
    background-color: #141414;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/user/blind_boxes.vue